import type { RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/application/stores/authStore";
import { useAppStore } from "@/application/stores/app";
import { useClubStore } from "@/application/stores/clubStore";
import { usePeriodStore } from "@/application/stores/periodStore";

export default async function authGuard(to: RouteLocationNormalized) {
  const authStore = useAuthStore();
  const appStore = useAppStore();
  const clubStore = useClubStore();
  const periodStore = usePeriodStore();

  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    appStore.setRedirectUrl();
    return { name: "auth.login" };
  }

  if (authStore.isLoggedIn) {
    clubStore.ensureLoaded().catch(() => undefined);
  }

  if (to.meta.requiresAuth && authStore.isLoggedIn && !periodStore.isLoaded) {
    await periodStore.fetch().catch(() => undefined);
  }

  if (
    authStore.isLoggedIn &&
    appStore.redirectUrl &&
    to.name !== "auth.login"
  ) {
    const redirectUrl = appStore.redirectUrl;
    appStore.clearRedirectUrl();
    if (redirectUrl !== to.fullPath) return redirectUrl;
  }

  if (to.name === "auth.login" && authStore.isLoggedIn) {
    return { name: "members.index" };
  }

  return true;
}
